import { useEffect, useRef } from 'react';
import { usePostHog } from '@posthog/react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import useUserUpdate from '@/api/users/useUserUpdate.ts';
import OnboardingStep from '$/_const/OnboardingStep.ts';
import type { TripData } from '$/models/Trip.model.ts';

const useFinishOnboarding = (trip: TripData | null) => {
  const posthog = usePostHog();
  const { user } = useAuthContext();
  const { mutateAsync: updateUser } = useUserUpdate();
  const started = useRef(false);

  useEffect(() => {
    if (!user || !trip || user.onboarding_step !== OnboardingStep.TRIP_CREATION || started.current) {
      return;
    }

    started.current = true;

    updateUser([{ onboarding_step: OnboardingStep.FINISHED }, { id: user.id }])
      .then(() => {
        posthog?.capture('onboarding_completed', {
          trip_destination: trip.trip_destination,
          who_is_joining: trip.who_is_joining,
        });
      })
      .catch((error: unknown) => {
        started.current = false;
        console.error('Error finishing onboarding: ', error);
        posthog?.captureException(error, {
          operation: 'complete_onboarding',
          onboarding_step: 'trip_creation',
        });
      });
  }, [user, trip, updateUser, posthog]);
};

export default useFinishOnboarding;
